<template>
	<div>
		<v-menu
			v-model="visible"
			:position-x="position.x"
			:position-y="position.y"
			:nudge-top="nudgeTop"
			ref="v-menu"
			min-width="220"
			
		>
			<v-card>
				<v-list ref="v-menu-content" dense>
					<v-list-item class="link font-12" @click="setClipboard()">
						<v-icon class="mr-2" small>mdi-content-copy</v-icon> Skopiuj link
					</v-list-item>
					<v-list-item @click="openDialog()" class="link font-12">
						<v-icon class="mr-2" small>mdi-share</v-icon> Udostępnij w grupie
					</v-list-item>
				</v-list>
			</v-card>
			
		</v-menu>
	<share-group-select-dialog ref="groupsDialog" v-if="showDialog" :saving="saving" @closed="closeDialog" @selected="groupSelected" />
	</div>
</template>

<script>
const ShareGroupSelectDialog = import("@/components/wall/dialogs/ShareGroupSelectDialog");
import axios from 'axios';
export default {
	components: {
		ShareGroupSelectDialog: () => ({
			component: ShareGroupSelectDialog,
		}),
	},
	props: {
		post: {
			type: Object,
			default: null
		},
		attach: {
			type: String,
			required: true
		},
		nudgeTop: {
			type: Number,
			default: 0
		},


	},
	watch: {
		visible: function (v) {
			if (v)
			this.$nextTick(function () {
				this.calculateCoordinates()
			})
		}
	},
	data () {
		return {
			saving: false,
			visible: false,
			position: {
				x: 0,
				y: 0
			},
			showDialog: false
		}
	},
	computed: {

	},
	methods: {
		async groupSelected(group) {
			console.log("GROUP", group)
			if(group) {
				this.saving = true;
				await axios.post('sharings', {
					sourceable_id: this.post.id,
					sourceable_type: 'post',
					destinationable_id: group.id,
					destinationable_type: 'group'
				})
				.then(() => {
					this.$snackbar.success('Pomyślnie udostępniono post!')
					this.closeDialog();
				})
				.catch(error => {
					this.$snackbar.error({error});
				})
				this.saving = false;
			}
		},
		closeDialog() {
			this.showDialog = false;
		},
		openDialog() {
			this.showDialog = true;
			setTimeout(() => {
				this.$refs.groupsDialog.showDialog();
			}, 100)
		},
		setClipboard() {
			console.log('ENV',process.env.NODE_ENV !== 'development');
			let url = window.location.origin;
			if(process.env.NODE_ENV != 'development') {
				url += '/community';
			}
			url += '/post/' + this.post.id + '?ref=share';
			navigator.clipboard.writeText(url);
			this.$snackbar.success("Skopiowano link do schowka")
		},
		show() {
			this.visible = true
		},
		hide() {
			this.visible = false
		},
		/* eslint-disable */
		calculateCoordinates () {
			let parent = document.getElementById(this.attach);
			let parentRect = parent.getBoundingClientRect();
			let vmenu = this.$refs['v-menu-content'].parentElement
			this.position.x = parentRect.left - (parent.offsetWidth / 2) + 65
			this.position.y = parentRect.top - parentRect.height + 115
		}
		/* eslint-enable */
	},
}
</script>

<style lang="scss">
</style>
